let SkillsData = [
  { skillName: "HTML", skillValue: 95 },
  { skillName: "Css3", skillValue: 90 },
  { skillName: "Bootstrap (4,5)", skillValue: 95 },
  { skillName: "JavaScript", skillValue: 85 },
  { skillName: "JQuery", skillValue: 85 },
  { skillName: "ReactJS", skillValue: 80 },
  { skillName: "WordPress", skillValue: 90 },
  { skillName: "ExpressJS", skillValue: 90 },
  { skillName: "MongoDB", skillValue: 90 },
  { skillName: "Ecommerce (Wordpress Woocommerce)", skillValue: 80 },
  { skillName: "Shopify", skillValue: 90 },
  { skillName: "Figma", skillValue: 85 },
  { skillName: "Photoshop", skillValue: 95 },
  { skillName: "CorelDRAW", skillValue: 80 },
];

export default SkillsData;
